<template>
  <v-ons-page @show="showPage()">

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        {{ cultLabel }}
      </div>
    </v-ons-toolbar>

    <div class="content">

      <div class="content--perfdetail">
        <div class="pie-wrapper">
          <div class="arc" :data-value="arcValue"></div>
          <p class="perfdetail-score" @click="showTonne">
            {{ tonneStock.toLocaleString('fr') }} t
            <br />
            <span>
              sur {{ tonneTotal !== '' ? tonneTotal.toLocaleString('fr') : '__' }} t collectées
              &nbsp;<v-ons-icon icon="fa-pencil-alt"></v-ons-icon>
            </span>
          </p>
        </div>

      </div>

      <div>

        <v-ons-list-title modifier="perflist">
          Mes livraisons
        </v-ons-list-title>

        <v-ons-list modifier="noborder perflist">

          <v-ons-list-item v-for="(item, index) in listApports" :key="index" modifier="perfdetail chevron"
                           @click="showApport(index)" tappable>

            <div class="left">
              <span class="list-item__thumbnail" :style="{'background-image': cultIcon}" />
            </div>

            <div class="center">
              <span class="list-item__title">
                {{ item.label }}
              </span>
              <span class="list-item__subtitle">
                {{ getDateLabelFromIso(item.date) }}
              </span>
            </div>

            <div class="right">
              <div class="list-item__label">
                <span>
                  {{ item.tonne.toLocaleString('fr', { minimumFractionDigits: 3 }) }} t
                </span>
              </div>
            </div>

          </v-ons-list-item>

        </v-ons-list>

      </div>

    </div>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from "../store.js";

import AppCultureTonne from './CultureTonne.vue';
import AppApportFiche from './ApportFiche.vue';

export default {
  mixins: [mixinsCommons, mixinsCours],
  props: ['pageStack'],
  data() {
    return {
      refCulture: '',
      refDestination: '',
      arcValue: 0,
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    tonneStock() {
      return this.listApports.reduce(function (sum, apport) {
        sum += apport.tonne;
        return sum;
      }, 0);
    },
    tonneTotal() {
      return this.getTonneTotal(this.user.cultures, this.refCulture, this.refDestination);
    },
    referentiel() {
      return this.data.referentiel;
    },
    cultLabel() {
      return this.getCultLabel();
    },
    cultIcon() {
      return this.$getCultAsset(this.refCulture, this.refDestination, 'icon');
    },
    negoce() {
      return this.getNegoceAcces(this.data.negoce.list);
    },
    listApports() {
      var list = [];
      for (let i = 0; i < this.negoce.length; i++) {
        var negoceItem = this.negoce[i];
        var apportLabel = negoceItem.label;
        if(negoceItem.apport
          && negoceItem.apport.list[this.campagne]
          && negoceItem.apport.list[this.campagne][this.refCulture]
          && negoceItem.apport.list[this.campagne][this.refCulture][this.refDestination]){
            var negoceApport = negoceItem.apport.list[this.campagne][this.refCulture][this.refDestination];
            for (let j = 0; j < negoceApport.length; j++) {
              var apport = negoceApport[j];
              list.push({
                negoceIndex: i,
                apportIndex: j,
                label: apportLabel,
                date: apport.date,
                tonne: apport.tonne,
              });
            }
        }
      }
      list.sort(function (a, b) {
        if (a.date > b.date) {
          return -1;
        } else if (a.date == b.date) {
          if (a.negoceIndex > b.negoceIndex) {
            return -1;
          } else if (a.negoceIndex == b.negoceIndex) {
            if (a.apportIndex > b.apportIndex) {
              return -1;
            } else {
              return 1;
            }
          } else {
            return 1;
          }
        } else {
          return 1;
        }
      });
      return list;
    }
  },
  methods: {
    showPage() {
      this.arcValue = this.tonneTotal !== '' ? Math.min(100, Math.round(100 * this.tonneStock / this.tonneTotal)) : 0;
    },
    showTonne() {
      var refCulture = this.refCulture;
      var refDestination = this.refDestination;
      this.pageStack.push({
        extends: AppCultureTonne,
        data() {
          return {
            refCulture: refCulture,
            refDestination: refDestination,
            type: 'apport'
          }
        },
        onsNavigatorOptions: {
          animation: 'lift'
        }
      });
    },
    showApport(indexApport) {
      var refCulture = this.refCulture;
      var refDestination = this.refDestination;
      var apportItem = this.listApports[indexApport];
      var negoceItem = this.negoce[apportItem.negoceIndex];
      var apportInfos = negoceItem.apport.list[this.campagne][this.refCulture][this.refDestination][apportItem.apportIndex];
      this.pageStack.push({
        extends: AppApportFiche,
        data() {
          return {
            negoceId: negoceItem.id,
            refCulture: refCulture,
            refDestination: refDestination,
            apport: apportInfos
          }
        }
      });
    }
  }
}
</script>